import { queryOptions } from '@tanstack/react-query';
import { getSystem, listSystems } from '~/services/api/fetchers/system.api';
import { ResourceNameIdConverter } from '~/shared/models/ResourceNameIdConverter';

export const listSystemsQuery = queryOptions({
  queryKey: ['listSystems'],
  queryFn: listSystems,
});

export const getSystemQuery = (systemId: string) =>
  queryOptions({
    queryKey: ['getSystem', systemId],
    queryFn: () => getSystem(ResourceNameIdConverter.systemIdToName(systemId)),
  });
